/**
 * PublicRoutes: wrapper for pages accessible to everyone.
 *
 * For unauthenticated visitors the page renders normally. For authenticated
 * users who have verified their email but have NOT yet created a MongoDB
 * profile (which includes accepting Terms & Privacy), we redirect to
 * /create-profile so the account setup is completed before they can browse.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

import { useAuth } from '@/shared/contexts/AuthContext';

const PublicRoutes = ({ children }) => {
    const { user, loading, hasProfile, profileLoading } = useAuth();

    if (loading || profileLoading) return <div>Loading...</div>;

    // Authenticated user with verified email but no profile → force setup
    if (user && user.emailVerified && hasProfile === false) {
        return <Navigate to="/create-profile" replace />;
    }

    return children;
};

PublicRoutes.propTypes = {
    children: PropTypes.node.isRequired,
};

export default PublicRoutes;
